import { createContext } from 'react';

import { GetAllAssets } from '../queries/get-all-assets';

export const CurrentAssetsContext = createContext<
  [GetAllAssets.Output, ReturnType<typeof GetAllAssets.useQuery>]
>(
  // @ts-expect-error - This is a placeholder value that should never be used
  undefined,
);
